export default __webpack_public_path__ + "static/media/daily-bonus-ico.44bfbb31.svg";